import { Router, Route, Switch } from 'react-router';
import { useHistory, useRouteMatch, useLocation } from 'react-router-dom';
import withRole from 'components/Security/withRole';
import {
  ROLE_CREATE_ZONE,
  ROLE_EDIT_ZONE,
  ROLE_SHOW_ZONE,
} from 'helpers/roles';

import List from './List';
import Form from './Form';

export type ZonesRouterProps = {
  history: ReturnType<typeof useHistory>;
  location: ReturnType<typeof useLocation>;
  match: ReturnType<typeof useRouteMatch>;
};

const Zones = () => {
  const history = useHistory();
  const match = useRouteMatch();
  const location = useLocation();

  const ListSecured = withRole(ROLE_SHOW_ZONE, List);
  const CreateForm = withRole(ROLE_CREATE_ZONE, Form);
  const EditForm = withRole(ROLE_EDIT_ZONE, Form);

  const routerProps = { history, match, location };

  return (
    <Router history={history}>
      <Switch>
        <Route
          exact={true}
          path={`${match.url}/`}
          render={parentProps => (
            <ListSecured {...routerProps} {...parentProps} />
          )}
        />
        <Route
          path={`${match.url}/add`}
          render={() => <CreateForm {...routerProps} />}
        />
        <Route
          path={`${match.url}/edit/:id`}
          render={parentProps => <EditForm {...routerProps} {...parentProps} />}
        />
      </Switch>
    </Router>
  );
};

export default Zones;
